import axios from 'axios';
import { API } from 'configs/api';

export const offerService = {
  getOffers: () => axios.get(API.requests, { token: true }),
  getOffer: (offerId) => axios.get(`${API.offers}/${offerId}`, { token: true }),
  getHotOffers: () => axios.get(API.hotOffers, { token: false }),
  getHotOffer: (id) => axios.get(`${API.hotOffer}/${id}`, { token: false }),
};
